import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import  Amplify from 'aws-amplify';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root") 
);



/*Amplify.configure ({
    Auth: {
       mandatorySignIn:true,

       region: "us-west-2",

       userPoolId: "us-west-2_5KglR0Hmv", 

       userPoolWebClientId: "2iksg0qboba81l8nl5emivha1s" 
    }

});*/


/*Amplify.configure ({

    Auth: {
       mandatorySignIn:true,

       region: "us-west-2",

       userPoolId: "us-west-2_5KglR0Hmv",  //User pool - 7fqu8n //us-west-2_LFA6aTeoG

       userPoolWebClientId: "3r8p8dskolorgad9e73hm7kli6" //5m4ol4f5g76clh574p1ra33ald //2iksg0qboba81l8nl5emivha1s//3r8p8dskolorgad9e73hm7kli6
    }

});*/


Amplify.configure ({

    Auth: {
      
       mandatorySignIn:true,

       region: "us-west-2",

       userPoolId: "us-west-2_OCsKhMAAK", 

       userPoolWebClientId: "3r8p8dskolorgad9e73hm7kli6" // //5m4ol4f5g76clh574p1ra33ald
    }

});



